export default [
    {
        text: 'N° Ticket',
        value: 'id',
    },
    {
        text: 'Fecha/Hora',
        value: 'created_at',
    },
    {
        text: 'Tipo',
        value: 'pos_sale_type_id',
    },
    {
        text: 'Cliente',
        value: 'sl_customer_id',
    },
    {
        text: 'Vendedor',
        value: 'sellerName',
    },
    {
        text: 'Estado',
        value: 'state',
    },
    {
        text: 'Total',
        value: 'ticket_total',
    },
    {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
    },
]
